


import styled from "styled-components";
import { VSuccess } from "../../constants/images";
import { TextLink } from "../common/TextLink";
import { Colors } from "../../style/colors";




interface ThankUProps {
  title:string;
  text:string;
  actionText:string;
  actionUrl:string;

}

export const ThankU = ({title,text,actionText,actionUrl}:ThankUProps) => {




  return (
    <>
    <Container>
    <Icon src={VSuccess} />
    <Title>{title}</Title>
    <Text>{text}</Text>
    <br />
    
    <TextLink route={actionUrl} fontSize="16px">{actionText}</TextLink>
      
    </Container>
      
    </>
  );
};


const Icon = styled.img`
width: 160px;
width: 160px;
`

const Title = styled.h2``

const Text = styled.div`
color: ${Colors.text};
font-size: 16px;
`

const Container = styled.div`
display: flex;
justify-content: center;
flex-direction: column;
align-items: center;
min-height: 60vh;
`